/* pdp-atc.js — shared PDP commerce + reviews wiring (phase 2a, built dark; loaded by nothing yet).
   Replaces the per-product window.<Name>Add family (JadeOilAdd / RoseOttoAdd / SanctumAdd) with one
   data-attribute-driven module. The gallery/media engine is a separate file (pdp-gallery.js).

   IDENTITY, PARAMETERISED (nothing product-specific is hardcoded):
     - Namespace: read from `[data-pdp-namespace]` (default 'pdp'). Drives the per-page
       selected-variant global so two PDP sections on one page never clobber each other's pick:
       window.__ssPick[namespace] instead of the old flat window.__ssPickJade / __ssPickRose.
     - Config: JSON in `<script data-pdp-config>` (title/handle/locale/reviewsWebhook), same island
       shape the shipped pdp-reviews.liquid already uses. No per-product element ids.

   COMPAT SHIM (per page, opt-in): a page may set `data-pdp-add-alias="JadeOilAdd"` on the scope and
   this module exports `window.JadeOilAdd = window.SacrasoulPdpAdd`, so any analytics/Klaviyo/GTM code
   still calling the old global keeps working through the migration. Grep before dropping the alias.

   The reviews wall / lightbox / write-a-review modal / star picker / proof box and the dialog stack
   they share moved to assets/pdp-reviews-wall.js (2026-09-27), loaded only by the sections whose page
   renders a reviews list (#rlist). Nothing here depends on it.

   RUNS ONCE, FIRST (7 Oct 2026). On the templates snippets/pdp-atc-script.liquid lists, the head loads this file as
   the second deferred script in the document (right after sacrasoul-cart-boot.js), so Add to cart is wired as soon as
   the page is parsed rather than after the ~28 deferred scripts in front of the section's tag; on any other template
   the section loads it where it always did. Still `defer`, so every control, bar and offer below exists when it runs.
   It stops on a second run: two tags would bind every control, observer and change handler twice (only the in-flight
   latch in SacrasoulPdpAdd kept a double tap to one add). */
(function(){
if(window.__ssPdpAtcRan)return;
window.__ssPdpAtcRan=true;

var SCOPE=document.querySelector('[data-pdp-namespace]');
var NS=(SCOPE&&SCOPE.getAttribute('data-pdp-namespace'))||'pdp';
window.__ssPick=window.__ssPick||{};

/* ---- add to cart: one writer, cart-drawer with a plain /cart fallback ---- */
/* The fallback keeps the shopper's market. German, Czech and Dutch are PATH
   prefixes on sacrasoul.com, so a bare '/cart' or '/cart/add.js' from
   /de-eu/products/... lands in the UK storefront (#2393 fixed the same fault in
   templates/cart.liquid). Shopify.routes.root is the locale root Shopify itself
   prints for this request ('/' or '/de-eu/'), the value of routes.root_url. */
function __ssCartRoute(p){var r=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root;if(typeof r!=='string'||!r)r='/';if(r.charAt(r.length-1)!=='/')r+='/';return r+p;}
var __ssLastAdd={id:0,t:0};
var __ssAddPending=false,__ssAddRelease=0;
var __ssAddGeneration=0,__ssAddOperation=null;
/* Every customer add control this module owns. Marked aria-busy while an add is in
   flight so a shopper sees the tap register on a slow connection instead of tapping
   again. Anchors cannot take `disabled`, so the flag below is the real guard. */
function __ssAddControls(){return [].slice.call(document.querySelectorAll('#atc,[data-sticky-add],.offer [data-atc],[data-kq-add]'));}
function __ssAddBusy(on){__ssAddControls().forEach(function(el){if(on)el.setAttribute('aria-busy','true');else el.removeAttribute('aria-busy');});}
function __ssAddSettle(){if(__ssAddRelease){clearTimeout(__ssAddRelease);__ssAddRelease=0;}__ssAddPending=false;__ssAddBusy(false);}

/* A retired operation may neither post later nor release a newer tap's lock.
   Once an additive write has left, an unreadable answer is NOT permission to
   replay it. Keep ownership and move to the cart to inspect server truth. */
function __ssOperationCurrent(op){return __ssAddOperation===op&&!op.abandoned;}
function __ssOperationSettle(op){if(__ssAddOperation===op){op.abandoned=true;__ssAddSettle();}}
function __ssOperationTimeout(op,variantId){
  if(!__ssOperationCurrent(op)||op.delegated)return;
  op.abandoned=true;
  __ssAddFailed(variantId,0);
  if(op.issued){window.location=__ssCartRoute('cart');return;}
  __ssOperationSettle(op);
}
function __ssWaitForCartOwner(op){
  var until=Date.now()+4000;
  return new Promise(function(resolve,reject){
    function check(){
      if(!__ssOperationCurrent(op)||Date.now()>=until){reject(new Error('Cart owner unavailable'));return;}
      if(window.SacrasoulCart&&window.SacrasoulCart.addAndOpen){resolve(window.SacrasoulCart);return;}
      setTimeout(check,50);
    }
    check();
  });
}

/* ---- availability gate ----
   Two sources of truth, in order. The hero pack radio is what the SERVER
   rendered about stock — snippets/pdp-hero.liquid writes `disabled` on a
   sold-out tier. __ssDead is what Shopify said AFTER that, during this page's
   life. Every add control funnels through SacrasoulPdpAdd, so the gate lives
   there once.

   Before this, a page whose tiers were ALL sold out had nowhere to move the
   selection (the "pick the first available" block below finds none), kept the
   disabled radio checked, and posted its dead id. /cart/add.js answered 422
   "'…' is already sold out". PostHog, one session on 2026-07-31 between 05:28
   and 05:29 (+02:00): six ss_add_to_cart_failed, every one source=product_atc
   on /en-us/products/inner-sanctum-attar — one shopper tapping a dead button
   six times in ninety-four seconds. A sold-out variant now never reaches the
   network.

   The six matching uncaught exceptions in that same session are NOT this file's
   to fix and are not fixed here: their stack is cartAddItemsRaw ->
   parseJsonResponse inside the cart engine, and the quiet() guard in #962
   closed that leak on 2026-08-01, the day after these events. PostHog shows
   none since. */
var __ssDead={};
function __ssPackRadio(vid){
  if(vid===undefined||vid===null||vid==='')return null;
  var all=document.querySelectorAll('#packs .pack input[data-vid]');
  for(var i=0;i<all.length;i++){if(String(all[i].getAttribute('data-vid'))===String(vid))return all[i];}
  return null;
}
/* 'sold' | 'live' | 'unknown'. Unknown means the page rendered nothing about
   this id — a K&Q cross-sell variant belongs to another product and has no pack
   radio here. Unknown is not a sellout, and equally not proof of life: a control
   the server rendered dead must never be re-lit off an id this page cannot
   judge. Only __ssDead survives for those, which is what keeps a rejected
   cross-sell variant from being posted again after the 700ms window. */
function __ssAvail(vid){
  if(vid===undefined||vid===null||vid==='')return 'unknown';
  if(__ssDead[String(vid)])return 'sold';
  var r=__ssPackRadio(vid);
  return r?(r.disabled?'sold':'live'):'unknown';
}
function __ssSoldOut(vid){return __ssAvail(vid)==='sold';}
function __ssSoldOutLabel(){
  var a=document.getElementById('atc'),l=a&&a.getAttribute('data-soldout-label');
  if(l)return l;
  var lang=(document.documentElement.lang||'en').slice(0,2).toLowerCase();
  return lang==='pl'?'Wyprzedane':lang==='cs'?'Vyprodáno':lang==='de'?'Ausverkauft':'Sold out';
}
/* Paint ONE control. 'unknown' paints nothing, in both directions.

   The hero button carries two label spans, so its price markup (#atcprice, which
   the pack-change handler keeps writing) is hidden, never overwritten. Every
   other control is a single label, and those get their whole innerHTML parked
   and restored — the offer CTA holds a lock icon and a price span, and a
   textContent swap would flatten both away for good the moment a shopper
   switched back to a tier that still sells. */
function __ssPaintControl(el,state){
  if(!el||state==='unknown')return;
  var on=state==='sold',was=el.hasAttribute('data-sold-out');
  var live=el.querySelector('.atc-live'),oos=el.querySelector('.atc-oos');
  if(live||oos){
    if(live)live.hidden=on;
    /* The word only while sold: a hidden "Sold out" is still text to a crawler that renders the page. */
    if(oos){oos.textContent=on?__ssSoldOutLabel():'';oos.hidden=!on;}
  }else if(on&&!was){
    if(el.__ssLiveHtml===undefined)el.__ssLiveHtml=el.innerHTML;
    el.textContent=__ssSoldOutLabel();
  }else if(!on&&was&&el.__ssLiveHtml!==undefined){
    el.innerHTML=el.__ssLiveHtml;
  }
  if('disabled' in el)el.disabled=on; /* <button>; an <a> has no such property */
  if(on){el.setAttribute('aria-disabled','true');el.setAttribute('data-sold-out','true');}
  else{el.removeAttribute('aria-disabled');el.removeAttribute('data-sold-out');}
}
function __ssHeroVid(){if(window.__ssPick[NS])return window.__ssPick[NS];var c=document.querySelector('#packs .pack input:checked');return c&&c.getAttribute('data-vid');}
/* Assigned by the offer block below. The offer CTA buys the picked TILE and the
   K&Q button buys its own bundle, so neither can be judged on the hero pack. */
var __ssOfferVid=function(){return null;};
/* Every add control, each judged by the variant IT would add. Painting them all
   off the hero left the offer CTA and the cross-sell lit over an add the gate
   then refused — a tap that does nothing, which reads worse than the drawer line
   it replaced. */
function __ssRefreshAddState(){
  var hero=__ssAvail(__ssHeroVid());
  __ssPaintControl(document.getElementById('atc'),hero);
  __ssPaintControl(document.querySelector('[data-sticky-add]'),hero);
  /* The five bundle PDPs (first-flame, alchemist, trinity, the-sanctum,
     king-queen) carry a THIRD control: the desktop buy bar, which
     product-first-flame-r13.js binds to this module's money path and reveals
     above 990px once the panel has scrolled past. It buys the hero pack, so it
     is judged on the hero pack. Liquid wrote its render-time sold-out state and
     nothing read it again: a mid-session 422 retired the CTA and the mobile bar
     and left the only control a desktop shopper can still see reading "Add to
     cart" over a variant Shopify had just refused. */
  __ssPaintControl(document.querySelector('[data-ffr13-bar-add]'),hero);
  __ssPaintControl(document.querySelector('.offer [data-atc]'),__ssAvail(__ssOfferVid()));
  var kq=document.querySelector('[data-kq-add]');
  if(kq)__ssPaintControl(kq,__ssAvail(kq.getAttribute('data-kq-add')));
}
/* Shopify's rejection is the newer truth about stock than anything this page
   rendered. Fold it into the page's own availability state (the radio) so the
   next tap is refused locally instead of posting again. err.ssSoldOut is set by
   the cart engine, which has already resolved cap-vs-sellout; the 422 + message
   test is the fallback for the cold-boot path. */
function __ssIsSoldOutVerdict(err){
  if(!err)return false;
  if(err.ssSoldOut)return true;
  /* The engine's classifier RAN and did not say sold out: a cap, or the
     held-and-unanswered case it refuses to condemn. The raw sentence must not
     overrule that — Shopify uses the same words for a quantity cap. The
     message fallback below is only for errors no classifier ever touched
     (the cold-boot path). */
  if(err.ssVerdictSettled)return false;
  var status=Number(err.status||(err.data&&err.data.status)||0);
  return status===422&&__ssSoldOutMessage(err.message);
}
/* Shopify answers the sellout in the STOREFRONT's language, so the English-only
   test this replaced never fired on sacrasoul.pl ("Produkt … zostal juz
   wyprzedany") or on CS/DE/NL. Kept in step with isSoldOutMessage in
   assets/sacrasoul-cart-drawer.js — two assets, one definition of the sentence;
   a contract test pins the two stem lists to each other and to the storefront
   locale set, so a new language cannot join one asset in silence.
   Diacritics are folded so "vyprodan"/"vyprodano" land on one stem. */
function __ssSoldOutMessage(message){
  var text=String(message||'');
  try{text=text.normalize('NFD').replace(/[\u0300-\u036f]/g,'');}catch(e){}
  return /sold\s*out|wyprzedan|vyprodan|ausverkauft|uitverkocht/i.test(text);
}
function __ssMarkSoldOut(vid){
  if(vid===undefined||vid===null||vid==='')return;
  /* Record it BEFORE touching the DOM: a variant with no pack radio of its own
     leaves no rendered trace, and without this the next tap past the 700ms
     window posted the same dead id again. */
  __ssDead[String(vid)]=true;
  var r=__ssPackRadio(vid);
  if(r)r.disabled=true;
  var tile=document.querySelector('.offer .oo[data-vid="'+String(vid).replace(/["\\]/g,'')+'"]');
  if(tile){tile.setAttribute('aria-disabled','true');var ti=tile.querySelector('.oo-in');if(ti)ti.disabled=true;}
  __ssRefreshAddState();
}

function __ssSellingPlan(){
  var mode=document.querySelector('input[name="r45-mode"]:checked');
  if(!mode||mode.value!=='sub')return null;
  var plan=document.querySelector('input[name="r45-selling-plan"]:checked');
  var id=plan&&parseInt(plan.value,10);
  return id||null;
}
window.SacrasoulPdpAdd=function(variantId){
  variantId=parseInt(variantId,10);
  if(!variantId)return;
  /* Sold out is refused BEFORE the re-entrancy guards, so a dead tap never
     latches __ssAddPending and never spends the 700ms window either. */
  if(__ssSoldOut(variantId)){__ssMarkSoldOut(variantId);return;}
  /* Re-entrancy guard for the money path, in two parts.
     1. In-flight: while an add has not settled, a second tap is dropped. The time
        window alone did not close this — on a slow connection the drawer may not
        have painted after 700ms, and an impatient second tap queued a second unit.
     2. Time: a repeat of the SAME variant inside 700ms is dropped even after the
        first settled, which absorbs a double-tap on a fast connection. Keyed by
        variant, so picking a DIFFERENT pack and adding still works instantly.
     Both checks are synchronous with the tap, so neither can be raced. The
     in-flight flag follows the cart owner once delegated. Only the pre-owner
     wait and the independent one-time emergency path use our local deadline;
     the owner exclusively bounds its queued transport and reconciliation. */
  if(__ssAddPending)return;
  var _now=(window.performance&&performance.now)?performance.now():Date.now();
  if(__ssLastAdd.id===variantId&&(_now-__ssLastAdd.t)<700)return;
  __ssLastAdd={id:variantId,t:_now};
  __ssAddPending=true;__ssAddBusy(true);
  var op={generation:++__ssAddGeneration,abandoned:false,issued:false};
  __ssAddOperation=op;
  __ssAddRelease=setTimeout(function(){__ssOperationTimeout(op,variantId);},10000);
  var sellingPlan=__ssSellingPlan();
  // Subscriptions NEVER use an independent fallback writer. The lazy owner's
  // real cart-allocation reconciliation handles membership, duplicates and gifts.
  // If it cannot boot, fail before issuing any paid add. No cart read can wake
  // later and create a second subscription after a retry.
  if(sellingPlan||(window.SacrasoulCart&&window.SacrasoulCart.addAndOpen)){
    __ssWaitForCartOwner(op).then(function(owner){
      if(!__ssOperationCurrent(op))return;
      // Deadline ownership transfers with the operation, not when the owner's
      // queued POST eventually leaves. Its transport and reconciliation may
      // legitimately exceed our pre-delegation wait; never navigate over them.
      op.delegated=true;
      if(__ssAddRelease){clearTimeout(__ssAddRelease);__ssAddRelease=0;}
      return owner.addAndOpen(variantId,1,{},undefined,sellingPlan).then(function(){
        __ssOperationSettle(op);
      },function(err){
        if(!__ssOperationCurrent(op))return;
        // The owner explicitly distinguishes unknown commits from rejections.
        // Unknown is 'check cart', never permission for a second paid add.
        if(err&&err.ssCartUncertain){
          // The owner already shows the cart and its uncertainty notice. Keep
          // the no-replay latch, but neither navigate nor keep buttons busy.
          // The latch ends once the owner has read the cart and settled: the
          // drawer then shows whether the unit landed, and a further tap is a
          // deliberate new add. It used to hold until reload, leaving every add
          // button on the page silently dead (found 2026-09-27).
          op.abandoned=true;__ssAddBusy(false);__ssReleaseWhenSettled(owner,op);return;
        }
        __ssOperationSettle(op);
        if(__ssIsSoldOutVerdict(err))__ssMarkSoldOut(variantId);
      });
    },function(){if(__ssOperationCurrent(op)){__ssOperationSettle(op);__ssAddFailed(variantId,0);}});
  }else{
    // One-time-only emergency path. No preparatory read and no replay after an
    // uncertain POST. An obsolete callback cannot release another operation.
    if(!__ssOperationCurrent(op))return;
    op.issued=true;
    fetch(__ssCartRoute('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variantId,quantity:1})}).then(function(r){
      if(!__ssOperationCurrent(op))return;
      if(r&&r.ok){op.abandoned=true;window.location=__ssCartRoute('cart');return;}
      // Even 429 can hide an accepted additive write. Do not infer absence
      // from an HTTP refusal; the cart is the only safe next destination.
      __ssOperationTimeout(op,variantId);
    },function(){__ssOperationTimeout(op,variantId);});
  }
};
function __ssReleaseWhenSettled(owner,op){
  if(!owner||typeof owner.isSettled!=='function')return; // older owner: keep the latch
  var tries=0;
  (function poll(){
    if(__ssAddOperation!==op)return;
    var settled=false;try{settled=owner.isSettled()===true;}catch(e){}
    if(settled){__ssAddSettle();return;}
    if(++tries<240)setTimeout(poll,250); // 60 s; past that the latch stays, as before
  })();
}
function __ssAddFailed(variantId,status){
  if(window.console&&console.warn)console.warn('[SacrasoulPdpAdd] add to cart failed',variantId,status||'network');
  if(SCOPE)SCOPE.setAttribute('data-add-failed',String(status||'network'));
  try{document.dispatchEvent(new CustomEvent('sacrasoul:cart-add-failed',{detail:{variantId:variantId,status:status||0}}));}catch(e){}
}
/* opt-in backward-compat alias for the legacy per-product global name */
(function(){var alias=SCOPE&&SCOPE.getAttribute('data-pdp-add-alias');if(alias&&!window[alias])window[alias]=window.SacrasoulPdpAdd;})();

/* ---- hero variant picker + sticky bar + offer-tile sync ---- */
(function(){
  var heroVid=__ssHeroVid;
  var price=document.getElementById('atcprice');
  document.querySelectorAll('#packs .pack input').forEach(function(r){
    r.addEventListener('change',function(){window.__ssPick[NS]=this.getAttribute('data-vid');var p=this.getAttribute('data-price');if(price)price.textContent=p;var sbp=document.getElementById('sbprice');if(sbp)sbp.textContent=p;__ssRefreshAddState();});
  });
  /* If the default pack is sold out, select the first available one — and move
     the authoritative pick with it. __ssHeroVid() prefers window.__ssPick[NS]
     over the checked radio, so a pick left pointing at the dead default (set
     here, or by any other initialiser on the page) would gate and buy the tier
     the shopper is not looking at. */
  (function(){
    var c=document.querySelector('#packs .pack input:checked'),cur=__ssPackRadio(window.__ssPick[NS]);
    if(!(c&&c.disabled)&&!(cur&&cur.disabled))return;
    var first=document.querySelector('#packs .pack input:not([disabled])');
    if(!first)return;
    first.checked=true;window.__ssPick[NS]=first.getAttribute('data-vid');
    var p=first.getAttribute('data-price'),pe=document.getElementById('atcprice');if(pe)pe.textContent=p;
    var sb=document.getElementById('sbprice');if(sb)sb.textContent=p;
  })();
  /* After the normalisation above, and only then: when EVERY pack is sold out
     there is no available radio to move to, and this is the state that used to
     ship a live button over a dead variant. */
  __ssRefreshAddState();
  var atc=document.getElementById('atc');
  if(atc)atc.addEventListener('click',function(){window.SacrasoulPdpAdd(heroVid());});
  var sba=document.querySelector('[data-sticky-add]');
  if(sba)sba.addEventListener('click',function(e){e.preventDefault();window.SacrasoulPdpAdd(heroVid());});

  // offer tiles → hero pack sync (guards a sold-out tile from pinning a dead variant)
  var scope=document.querySelector('.offer');
  if(scope){
    var opts=scope.querySelector('[data-opts]'),out=scope.querySelector('[data-price-out]');
    function offerVid(){var s=opts&&opts.querySelector('.oo.sel');return s&&s.getAttribute('data-vid');}
    __ssOfferVid=offerVid;
    /* The offer tiles render no availability state of their own, so the shared gate
       above is the only truth about whether a variant can be bought — the hero pack
       radio for a tier this page rendered, __ssDead for one Shopify has since
       refused. */
    function offerSoldOut(tile){return __ssSoldOut(tile.getAttribute('data-vid'));}
    /* One selection routine for both tile generations. Every offer tile in the theme now
       renders from snippets/pdp-block-offer.liquid and carries a real <input type=radio
       class=oo-in> (keyboard + screen readers for free) — the bundles were the last
       label-only holdouts and migrated in phase 2e. The click path below stays as the
       fallback for any tile that arrives without an input. Both funnel here. */
    function selectTile(it){
      if(offerSoldOut(it))return;
      opts.querySelectorAll('.oo').forEach(function(x){x.classList.remove('sel')});it.classList.add('sel');
      var _in=it.querySelector('.oo-in');if(_in&&!_in.checked)_in.checked=true;
      /* the sticky bar reads the hero pack; without this a shopper who picks an offer
         tile, scrolls past the offer block and taps the sticky bar buys the hero default. */
      var _v=it.getAttribute('data-vid');
      if(_v){
        var _r=document.querySelector('#packs .pack input[data-vid="'+_v+'"]');
        if(_r){window.__ssPick[NS]=_v;
          if(!_r.checked){_r.checked=true;_r.dispatchEvent(new Event('change',{bubbles:true}));}}
        else{window.__ssPick[NS]=_v;
          var _sb=document.getElementById('sbprice');
          if(_sb&&it.getAttribute('data-price'))_sb.textContent=it.getAttribute('data-price');}}
      if(out)out.textContent=it.getAttribute('data-price');
      /* The offer CTA follows the tile, not the hero pack: a cross-product tile
         moves nothing on #packs, so the change handler above never fires. */
      __ssRefreshAddState();
    }
    if(opts){
      /* Mark sold-out tiles up front rather than letting a shopper tap a dead one, and
         move the pre-selected tile off a sold-out variant the way the hero does. */
      opts.querySelectorAll('.oo').forEach(function(it){
        if(offerSoldOut(it)){it.setAttribute('aria-disabled','true');
          var _in=it.querySelector('.oo-in');if(_in)_in.disabled=true;}});
      var _selNow=opts.querySelector('.oo.sel');
      if(_selNow&&offerSoldOut(_selNow)){
        var _first=[].slice.call(opts.querySelectorAll('.oo')).filter(function(x){return !offerSoldOut(x);})[0];
        if(_first){_selNow.classList.remove('sel');_first.classList.add('sel');
          var _fi=_first.querySelector('.oo-in');if(_fi)_fi.checked=true;
          if(out&&_first.getAttribute('data-price'))out.textContent=_first.getAttribute('data-price');}
      }
      opts.querySelectorAll('.oo').forEach(function(it){
        var _in=it.querySelector('.oo-in');
        if(_in){
          /* radio generation: change covers click, Tab and arrow keys natively */
          _in.addEventListener('change',function(){selectTile(it);});
        }else{
          /* legacy generation: click only. A sold-out tile selects nothing — offerVid()
             reads .oo.sel, so letting the class land here would post a sold-out id. */
          it.addEventListener('click',function(e){e.preventDefault();selectTile(it);});
        }
      });
    }
    var offerAtc=scope.querySelector('[data-atc]');
    if(offerAtc)offerAtc.addEventListener('click',function(e){e.preventDefault();window.SacrasoulPdpAdd(offerVid());});
    /* The offer block boots after the hero, so the first refresh above ran with
       __ssOfferVid still returning null and left this CTA unpainted. */
    __ssRefreshAddState();
    var oio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('shown');oio.unobserve(e.target);}})},{threshold:.04});
    oio.observe(scope);
  }
})();

/* ---- sticky buy bar visibility ---- */
(function(){var bar=document.getElementById('stickybuy');if(!bar)return;var atc=document.getElementById('atc'),offer=document.getElementById('sec-offer');var atcIn=false,offerIn=false;function upd(){var s=!atcIn&&!offerIn;bar.classList.toggle('show',s);bar.setAttribute('aria-hidden',s?'false':'true');var cta=bar.querySelector('.sb-cta');if(cta)cta.tabIndex=s?0:-1;}if(atc)new IntersectionObserver(function(es){atcIn=es[0].isIntersecting;upd();},{threshold:0}).observe(atc);if(offer)new IntersectionObserver(function(es){offerIn=es[0].isIntersecting;upd();},{threshold:.18}).observe(offer);upd();})();

/* ---- King & Queen cross-sell add (adds the bundle variant when configured) ---- */
(function(){var b=document.querySelector('[data-kq-add]');if(b)b.addEventListener('click',function(e){e.preventDefault();window.SacrasoulPdpAdd(b.getAttribute('data-kq-add'));});})();

/* Tells the motion gate in snippets/pdp-motion-gate.liquid an animator arrived,
   so its 2s watchdog stands down. Set after the offer observer is wired, so a
   throw on the way here still opens the gate. The reviews-wall observer that
   used to precede it now lives in assets/pdp-reviews-wall.js; if that file
   fails, the gate's own floor observer still reveals a block a reader stops on. */
window.__ssPdpBooted=true;

})();
